import { render, staticRenderFns } from "./CarrierDestinationPriceFormModal.vue?vue&type=template&id=06e65393&scoped=true&"
import script from "./CarrierDestinationPriceFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationPriceFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e65393",
  null
  
)

export default component.exports